import { styledComponent, Box } from '@hermes/web-components'

export const SuggestedSearchContainer = styledComponent(Box)(({ theme }) => ({
  ...theme.custom.SuggestedSearch.container,
  height: 'fit-content',
  borderRadius: '16px',
  '& .splide__pagination__page': {
    background: '#1A3586',
    opacity: 1,
    width: '12px',
    height: '12px',
    '&.is-active': {
      opacity: 1,
      width: '16px',
      height: '16px'
    }
  },
  '& .splide__pagination': {
    paddingTop: '16px',
    bottom: 0,
    position: 'relative',
    gap: '15px'
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: '16px',
    borderRadius: 0
  }
}))

export const Button = styledComponent('button')`
  border: none;
  background-color: transparent;
`

export const ButtonsContainer = styledComponent('div')(({ theme }) => ({
  display: 'flex',
  gap: '28px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '24px'
  },
  '@media (max-width: 640px)': {
    display: 'none'
  }
}))
